<template>
	<div class="image-chooser d-flex flex-column">
		<div class="image-chooser-thumbnail-wrap">
			<img
				v-if="thumbnail"
				@click="showMediaLibraryModal(data)"
				:src="thumbnail"
				class="image-chooser-thumbnail"
				alt=""
			/>
			<button v-if="thumbnail" class="image-chooser-remove" type="button" @click="removeImage()" title="Remove Image">
				<font-awesome-icon :icon="['fas', 'trash']" />
			</button>
		</div>
		<div class="image-chooser__field">
			<input class="form-control form-control-sm url-input" type="text" v-model="data.value" />
			<button
				@click="showMediaLibraryModal(data)"
				title="Open Media Library"
				class="btn btn-primary btn-sm media-library-btn"
			>
				<font-awesome-icon :icon="['fas', 'images']" />
			</button>
		</div>
	</div>
</template>

<script>
export default {
	name: 'ImageChooser',
	props: ['data'],
	data() {
		return {}
	},
	computed: {
		thumbnail: function() {
			let thumb = this.data.value
			//let name = thumb.substr(0, thumb.lastIndexOf('.'))
			//let extension = thumb.substring(thumb.lastIndexOf('.') + 1)
			//thumb = name + '-150x150.' + extension
			return thumb
		},
	},
	watch: {
		'data.value': function() {
			this.$emit('change')
		},
	},
	created() {},
	methods: {
		showMediaLibraryModal(element) {
			this.$emit('showMediaLibraryModal', element)
		},
		removeImage() {
			this.data.value = ''
		},
	},
	emits: ['showMediaLibraryModal', 'change'],
}
</script>
<style scoped>
.image-chooser__field {
	display: flex;
	align-items: stretch;
	border: 1px solid #cbd5e1;
	border-radius: 12px;
	overflow: hidden;
	background: #ffffff;
}

.url-input {
	border: 0 !important;
	border-radius: 0 !important;
	background: #f2f5f8 !important;
	box-shadow: none !important;
}

.url-input:focus {
	border: 0 !important;
	box-shadow: none !important;
}

.media-library-btn {
	border-radius: 0 !important;
	width: 56px;
	border: 0 !important;
	background: #d9eafe;
	color: #1d4ed8;
}

.media-library-btn:hover {
	background: #c8defa;
	color: #1e40af;
}

.image-chooser-thumbnail {
	width: 100%;
	height: 100px;
	object-fit: scale-down;
	border-top-left-radius: 5px;
	border-top-right-radius: 5px;
	cursor: pointer;
}

.image-chooser-thumbnail-wrap {
	position: relative;
}

.image-chooser-remove {
	position: absolute;
	top: 8px;
	right: 8px;
	background-color: rgba(255, 255, 255, 0.95);
	border: 1px solid #e2e8f0;
	color: #dc2626;
	width: 28px;
	height: 28px;
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 50% !important;
	box-shadow: 0 1px 4px rgba(15, 23, 42, 0.22);
	z-index: 2;
	padding: 0;
	opacity: 0;
	pointer-events: none;
	transition: opacity 0.2s ease;
}

.image-chooser-thumbnail-wrap:hover .image-chooser-remove {
	opacity: 1;
	pointer-events: auto;
}
</style>
